module.exports = __webpack_public_path__ + "static/media/icon-error.0081c5d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Shared/Alerts/icon-error.svg
// module id = 1434
// module chunks = 2